import { render, staticRenderFns } from "./LotteryWinner.vue?vue&type=template&id=6e84b72b&scoped=true&"
import script from "./LotteryWinner.vue?vue&type=script&lang=js&"
export * from "./LotteryWinner.vue?vue&type=script&lang=js&"
import style0 from "./LotteryWinner.vue?vue&type=style&index=0&id=6e84b72b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84b72b",
  null
  
)

export default component.exports